// extracted by mini-css-extract-plugin
export default {"available":"FeatureValue_available__SnV8s","unavailable":"FeatureValue_unavailable__Q97aI"};